export default "__VITE_ASSET__jg0ZZJ_h__"